import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <div>
      <div className="footer">
        <strong>Cryptopedia</strong> <br></br> Developed in India
      </div>
    </div>
  );
};

export default Footer;
